import { pendingProjectConsentStorage } from "@sg-protect/core";
import { useGetSetupUrl, useTenantContext } from "@sg-protect/shell";
import { type PropsWithChildren, useEffect } from "react";
import { Navigate, useParams } from "react-router";
import { useIsTenantConsented } from "#hooks/useIsTenantConsented.ts";

export function ConsentBoundary({ children }: PropsWithChildren) {
    const consentRedirectUrl = useGetSetupUrl("migrateAssessment");
    const isConsented = useIsTenantConsented(useTenantContext().currentTenant?.tenantId);
    const { projectId } = useParams();

    useEffect(() => {
        if (!isConsented && projectId !== undefined) {
            pendingProjectConsentStorage.setProject(projectId);
        }
    }, [isConsented, projectId]);

    if (!isConsented) {
        return <Navigate to={consentRedirectUrl} replace />;
    }

    return children;
}
